console.log('🎨 ===== LL-EMBROIDERY.JS LOADING ===== ');
console.log('🎨 Script loaded at:', new Date().toISOString());
console.log('🎨 Document ready state:', document.readyState);

/**
 * Embroidery Customization Class
 * Handles all interactions for the embroidery customization feature
 */
class EmbroideryCustomization {
  constructor(blockId, options = {}) {
    this.blockId = blockId;
    this.options = options;
    this.embroideryPrice = options.embroideryPrice || 1500; // 默认价格15.00美元
    this.isRemoving = false; // Flag to prevent state restoration during removal
    
    // Initialize elements
    this.initElements();
    
    // Initialize custom font selector
    this.initCustomFontSelector();
    
    // Bind events
    this.bindEvents();
    
  }

  initElements() {
    this.container = document.querySelector(`[data-block-id="${this.blockId}"]`);
    this.drawer = document.getElementById(`embroidery-drawer-${this.blockId}`);
    this.textInput = document.getElementById(`ll-embroidery-text-${this.blockId}`);
    this.fontSelect = document.getElementById(`ll-embroidery-font-${this.blockId}`);
    this.colorSelect = document.getElementById(`ll-embroidery-color-${this.blockId}`);
    this.applyButton = document.getElementById(`ll-embroidery-apply-${this.blockId}`);
    this.cancelButton = document.getElementById(`ll-embroidery-cancel-${this.blockId}`);
    this.removeButton = document.getElementById(`ll-embroidery-remove-${this.blockId}`);
    this.errorMessage = document.getElementById(`ll-embroidery-error-${this.blockId}`);
    this.priceDisplay = document.getElementById(`ll-embroidery-price-display-${this.blockId}`);
    
    // Hidden form inputs
    this.hiddenTextInput = document.getElementById(`properties-embroidery-text-${this.blockId}`);
    this.hiddenFontInput = document.getElementById(`properties-embroidery-font-${this.blockId}`);
    this.hiddenColorInput = document.getElementById(`properties-embroidery-color-${this.blockId}`);
    this.hiddenColorValueInput = document.getElementById(`properties-embroidery-color-value-${this.blockId}`);
  }

  initCustomFontSelector() {
    // Custom font selector logic
    const fontCards = this.drawer?.querySelectorAll('.ll-embroidery-font-card');
    fontCards?.forEach(card => {
      card.addEventListener('click', () => {
        // Remove active class from all cards
        fontCards.forEach(c => c.classList.remove('active'));
        // Add active class to clicked card
        card.classList.add('active');
        
        // Update the hidden select
        const fontValue = card.dataset.fontValue;
        if (this.fontSelect && fontValue) {
          this.fontSelect.value = fontValue;
          this.updateHiddenInputs();
        }
      });
    });
  }

  bindEvents() {
    // Apply button
    this.applyButton?.addEventListener('click', () => this.applyEmbroidery());
    
    // Cancel button
    this.cancelButton?.addEventListener('click', () => this.cancelEmbroidery());
    
    // Remove button
    this.removeButton?.addEventListener('click', () => this.removeEmbroidery());
    
    // Input change events
    this.textInput?.addEventListener('input', () => this.updateHiddenInputs());
    this.fontSelect?.addEventListener('change', () => this.updateHiddenInputs());
    this.colorSelect?.addEventListener('change', () => this.updateHiddenInputs());
    
    // Color select change event for updating color value
    this.colorSelect?.addEventListener('change', (e) => {
      const selectedOption = e.target.selectedOptions[0];
      const colorValue = selectedOption?.dataset.colorValue || '';
      if (this.hiddenColorValueInput) {
        this.hiddenColorValueInput.value = colorValue;
      }
    });
  }

  updateHiddenInputs() {
    // 先启用字段，然后更新值
    const hiddenInputs = [
      this.hiddenTextInput,
      this.hiddenFontInput, 
      this.hiddenColorInput,
      this.hiddenColorValueInput
    ];
    
    // 启用所有隐藏字段以便更新值
    hiddenInputs.forEach(input => {
      if (input) {
        input.disabled = false;
      }
    });
    
    // 更新字段值
    if (this.hiddenTextInput) this.hiddenTextInput.value = this.textInput?.value || '';
    if (this.hiddenFontInput) this.hiddenFontInput.value = this.fontSelect?.value || '';
    if (this.hiddenColorInput) this.hiddenColorInput.value = this.colorSelect?.options[this.colorSelect?.selectedIndex]?.text || '';
    
    // Update color value from selected option
    const selectedColorOption = this.colorSelect?.selectedOptions[0];
    if (this.hiddenColorValueInput && selectedColorOption) {
      this.hiddenColorValueInput.value = selectedColorOption.dataset.colorValue || '';
    }
  }

  handleCheckboxChange(event) {
    const isChecked = event.target.checked;
    
    if (isChecked) {
      // Show drawer to configure embroidery
      this.showDrawer();
    } else {
      // Clear all data and hide edit details
      this.clearEmbroideryData();
    }
  }

  async applyEmbroidery() {
    if (!this.validateInputs()) {
      return;
    }

    this.hideError();
    this.setLoading(true);

    try {
      // Update hidden inputs with current values
      this.updateHiddenInputs();
      
      // Get the controller for this block
      const controller = window[`embroideryController_${this.blockId}`];
      
      if (controller) {
        let success;
        
        if (controller.isSelected()) {
          // If already selected, just update properties
          success = await controller.updateEmbroideryProperties();
        } else {
          // If not selected, select embroidery (which adds to cart)
          success = await controller.selectEmbroidery();
        }
        
        if (success) {
          this.closeDrawer();
          
          // Trigger cart refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          this.showError('Failed to apply embroidery. Please try again.');
        }
      } else {
        this.showError('Embroidery controller not found. Please refresh the page.');
      }
    } catch (error) {
      console.error('Error applying embroidery:', error);
      this.showError('An error occurred. Please try again.');
    } finally {
      this.setLoading(false);
    }
  }

  async removeEmbroidery() {
    this.setLoading(true);
    this.isRemoving = true; // Set flag to prevent state restoration

    try {
      // Get the controller for this block
      const controller = window[`embroideryController_${this.blockId}`];
      
      if (controller) {
        const success = await controller.unselectEmbroidery();
        
        if (success) {
          this.clearEmbroideryData();
          this.closeDrawer();
          
          // Trigger cart refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          this.showError('Failed to remove embroidery. Please try again.');
        }
      } else {
        this.showError('Embroidery controller not found. Please refresh the page.');
      }
    } catch (error) {
      console.error('Error removing embroidery:', error);
      this.showError('An error occurred. Please try again.');
    } finally {
      this.setLoading(false);
      this.isRemoving = false; // Reset flag
    }
  }

  cancelEmbroidery() {
    this.closeDrawer();
  }

  validateInputs() {
    const text = this.textInput?.value?.trim();
    const font = this.fontSelect?.value;
    const color = this.colorSelect?.value;

    if (!text || !font || !color) {
      this.showError('Please complete all embroidery information');
      return false;
    }

    return true;
  }

  clearEmbroideryData() {
    // Clear form inputs
    if (this.textInput) this.textInput.value = '';
    if (this.fontSelect) this.fontSelect.selectedIndex = 0;
    if (this.colorSelect) this.colorSelect.selectedIndex = 0;
    
    // Clear and disable hidden inputs
    const hiddenInputs = [
      this.hiddenTextInput,
      this.hiddenFontInput, 
      this.hiddenColorInput,
      this.hiddenColorValueInput
    ];
    
    hiddenInputs.forEach(input => {
      if (input) {
        input.value = '';
        input.disabled = true;
      }
    });
    
    // Remove active font card selection
    const fontCards = this.drawer?.querySelectorAll('.ll-embroidery-font-card');
    fontCards?.forEach(card => card.classList.remove('active'));
  }



  showDrawer() {
    if (this.drawer) {
      this.drawer.setAttribute('open', '');
    }
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.removeAttribute('open');
    }
  }

  showError(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  setLoading(loading) {
    if (this.applyButton) {
      this.applyButton.disabled = loading;
      this.applyButton.textContent = loading ? 'Processing...' : 'Add Embroidery';
    }
    
    if (this.removeButton) {
      this.removeButton.disabled = loading;
    }
  }
}

// Utility function to format price
function formatPrice(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
  }
  return `$${(cents / 100).toFixed(2)}`;
}

// New function to check if embroidery is selected and build combined payload
console.log('🎯 ===== DEFINING window.addToCartEmbroidery FUNCTION =====');
window.addToCartEmbroidery = async function(formElement) {
  console.log('🎯 addToCartEmbroidery called with form:', formElement);
  
  // 检查是否正在执行removeEmbroidery操作，如果是则跳过
  if (window._isRemovingEmbroidery) {
    console.log('Skipping addToCartEmbroidery during removeEmbroidery operation');
    return;
  }
  
  // Enhanced checkbox detection - 支持form内部和外部关联的checkbox
  let embroideryCheckbox = formElement.querySelector('[data-addon-checkbox-input]:checked');
  let allCheckboxes = formElement.querySelectorAll('[data-addon-checkbox-input]');

  // 使用正确的选择器：ll-embroidery-checkbox-input
  if (!embroideryCheckbox) {
    embroideryCheckbox = formElement.querySelector('.ll-embroidery-checkbox-input:checked');
  }
  if (allCheckboxes.length === 0) {
    allCheckboxes = formElement.querySelectorAll('.ll-embroidery-checkbox-input');
  }

  // 如果form内部没有找到，查找通过form属性关联的外部checkbox
  const formId = formElement.getAttribute('id');
  if (formId && (!embroideryCheckbox || allCheckboxes.length === 0)) {
    console.log('🔍 Form内部未找到刺绣checkbox，查找form外部关联checkbox...');

    if (!embroideryCheckbox) {
      embroideryCheckbox = document.querySelector(`[data-addon-checkbox-input][form="${formId}"]:checked`) ||
                          document.querySelector(`.ll-embroidery-checkbox-input[form="${formId}"]:checked`);
    }

    if (allCheckboxes.length === 0) {
      allCheckboxes = document.querySelectorAll(`[data-addon-checkbox-input][form="${formId}"], .ll-embroidery-checkbox-input[form="${formId}"]`);
    }
  }
  
  // Also check for any embroidery-related checkboxes
  const allFormCheckboxes = formElement.querySelectorAll('input[type="checkbox"]');
  const embroideryRelatedCheckboxes = Array.from(allFormCheckboxes).filter(cb => {
    const id = cb.id?.toLowerCase() || '';
    const name = cb.name?.toLowerCase() || '';
    const className = cb.className?.toLowerCase() || '';
    return id.includes('embroidery') || name.includes('embroidery') || className.includes('embroidery');
  });
  
  console.log('🎨 Enhanced checkbox detection:', {
    totalAddonCheckboxes: allCheckboxes.length,
    checkedAddonCheckbox: !!embroideryCheckbox,
    addonCheckboxes: Array.from(allCheckboxes).map(cb => ({
      checked: cb.checked,
      id: cb.id,
      dataset: cb.dataset
    })),
    embroideryRelatedCheckboxes: embroideryRelatedCheckboxes.length,
    checkedEmbroideryRelated: embroideryRelatedCheckboxes.filter(cb => cb.checked).map(cb => ({
      checked: cb.checked,
      id: cb.id,
      name: cb.name
    }))
  });
  
  // Check embroidery properties - 支持form内部和外部关联的元素
  let hasEmbroideryText = formElement.querySelector('input[name="properties[Embroidery Text]"]')?.value?.trim();
  let hasEmbroideryFont = formElement.querySelector('input[name="properties[Embroidery Font]"]')?.value;
  let hasEmbroideryColor = formElement.querySelector('input[name="properties[Embroidery Color]"]')?.value;

  // 如果form内部没有找到，查找通过form属性关联的外部元素
  if (formId && (!hasEmbroideryText || !hasEmbroideryFont || !hasEmbroideryColor)) {
    console.log('🔍 Form内部未找到完整刺绣属性，查找form外部关联元素...');

    if (!hasEmbroideryText) {
      hasEmbroideryText = document.querySelector(`input[name="properties[Embroidery Text]"][form="${formId}"]`)?.value?.trim();
    }

    if (!hasEmbroideryFont) {
      hasEmbroideryFont = document.querySelector(`input[name="properties[Embroidery Font]"][form="${formId}"]`)?.value;
    }

    if (!hasEmbroideryColor) {
      hasEmbroideryColor = document.querySelector(`input[name="properties[Embroidery Color]"][form="${formId}"]`)?.value;
    }

    console.log('🔍 外部关联元素检查结果:', {
      hasEmbroideryText: hasEmbroideryText,
      hasEmbroideryFont: hasEmbroideryFont,
      hasEmbroideryColor: hasEmbroideryColor
    });
  }
  
  console.log('🎨 Embroidery properties check:', {
    hasEmbroideryText: !!hasEmbroideryText,
    hasEmbroideryFont: !!hasEmbroideryFont,
    hasEmbroideryColor: !!hasEmbroideryColor,
    embroideryText: hasEmbroideryText,
    embroideryFont: hasEmbroideryFont,
    embroideryColor: hasEmbroideryColor
  });
  
  // Check if we should proceed with embroidery logic
  const shouldProceed = embroideryCheckbox || 
    (embroideryRelatedCheckboxes.some(cb => cb.checked)) ||
    (hasEmbroideryText && hasEmbroideryFont && hasEmbroideryColor);
  
  if (!shouldProceed) {
    console.log('⚪ No embroidery data found, returning null');
    return null;
  }
  
  if (!embroideryCheckbox && (hasEmbroideryText || embroideryRelatedCheckboxes.some(cb => cb.checked))) {
    console.log('🔄 No addon checkbox checked but embroidery data found, proceeding with combined logic...');
  }
  
  console.log('✅ Proceeding with combined embroidery logic');
  
  // Find embroidery container and variant ID with enhanced logic
  let embroideryContainer = null;
  let embroideryVariantId = null;
  
  if (embroideryCheckbox) {
    embroideryContainer = embroideryCheckbox.closest('[data-embroidery-block="true"]');
  }
  
  // Fallback: search for embroidery container in the form
  if (!embroideryContainer) {
    embroideryContainer = formElement.querySelector('[data-embroidery-block="true"]');
    console.log('🔍 Fallback: Found embroidery container via form search:', !!embroideryContainer);
  }
  
  // Another fallback: search in the entire document
  if (!embroideryContainer) {
    embroideryContainer = document.querySelector('[data-embroidery-block="true"]');
    console.log('🔍 Fallback: Found embroidery container via document search:', !!embroideryContainer);
  }
  
  if (!embroideryContainer) {
    console.error('❌ Embroidery container not found anywhere');
    console.log('🔍 All containers with data-embroidery-block:', 
      Array.from(document.querySelectorAll('[data-embroidery-block]')).map(el => ({
        value: el.getAttribute('data-embroidery-block'),
        dataset: el.dataset
      }))
    );
    return null;
  }
  
  embroideryVariantId = embroideryContainer.getAttribute('data-variant-id');
  
  // Additional fallback for variant ID
  if (!embroideryVariantId) {
    embroideryVariantId = embroideryContainer.dataset.variantId;
    console.log('🔍 Fallback: Found variant ID via dataset:', embroideryVariantId);
  }
  
  // Try to find variant ID from embroidery-service product
  if (!embroideryVariantId) {
    const embroideryServiceSelect = formElement.querySelector('select[name="id"][data-product="embroidery-service"], input[name="id"][data-product="embroidery-service"]');
    if (embroideryServiceSelect) {
      embroideryVariantId = embroideryServiceSelect.value;
      console.log('🔍 Fallback: Found variant ID from embroidery service select:', embroideryVariantId);
    }
  }
  
  if (!embroideryVariantId) {
    console.error('❌ Embroidery variant ID not found');
    console.log('🔍 Container attributes:', embroideryContainer.attributes);
    console.log('🔍 Container dataset:', embroideryContainer.dataset);
    console.log('🔍 All variant selects in form:', 
      Array.from(formElement.querySelectorAll('select[name="id"], input[name="id"]')).map(el => ({
        value: el.value,
        dataset: el.dataset
      }))
    );
    return null;
  }
  
  return await buildCombinedPayload(formElement, embroideryCheckbox, embroideryContainer, embroideryVariantId);
};

// Helper function to build combined payload
async function buildCombinedPayload(formElement, embroideryCheckbox, embroideryContainer, embroideryVariantId) {
  console.log('🔨 Building combined payload...');
  
  // Get main product ID and quantity from form with enhanced search
  let mainProductId = formElement.querySelector('[name="id"]')?.value;
  const quantity = formElement.querySelector('[name="quantity"]')?.value || 1;
  
  // Fallback for main product ID
  if (!mainProductId) {
    const variantSelects = formElement.querySelectorAll('select[name="id"], input[name="id"]');
    for (const select of variantSelects) {
      if (select.value && select.value !== embroideryVariantId) {
        mainProductId = select.value;
        console.log('🔍 Fallback: Found main product ID from variant select:', mainProductId);
        break;
      }
    }
  }
  
  console.log('📋 Form data extracted:', {
    mainProductId,
    quantity,
    embroideryVariantId,
    allVariantSelects: Array.from(formElement.querySelectorAll('select[name="id"], input[name="id"]')).map(el => ({
      value: el.value,
      dataset: el.dataset
    }))
  });
  
  if (!mainProductId) {
    console.error('❌ Main product ID not found in form');
    console.log('🔍 Form elements analysis:', {
      allNamedInputs: Array.from(formElement.querySelectorAll('input[name]')).map(el => ({
        name: el.name,
        value: el.value,
        type: el.type
      })),
      allSelects: Array.from(formElement.querySelectorAll('select')).map(el => ({
        name: el.name,
        value: el.value
      }))
    });
    return null;
  }
  
  // Generate addon token for linking products
  const addonToken = '_ADDON-' + generateUUID();
  
  console.log('🎫 Generated addon token:', addonToken);
  
  // Build main product with addon properties
  const mainProduct = {
    id: mainProductId,
    quantity: parseInt(quantity),
    properties: {
      "_addonToken": addonToken,
      "_hasAddons": true
    }
  };
  
  // Add any existing form properties to main product (excluding embroidery properties)
  const formData = new FormData(formElement);
  for (const [key, value] of formData.entries()) {
    if (key.startsWith('properties[') && !key.includes('_embroidery') && !key.includes('Embroidery')) {
      const propertyName = key.match(/properties\[(.*?)\]/)[1];
      mainProduct.properties[propertyName] = value;
    }
  }
  
  // Get embroidery information from form - 支持form内部和外部关联的元素
  let embroideryText = formElement.querySelector(`input[name="properties[Embroidery Text]"]`)?.value || '';
  let embroideryFont = formElement.querySelector(`input[name="properties[Embroidery Font]"]`)?.value || '';
  let embroideryColor = formElement.querySelector(`input[name="properties[Embroidery Color]"]`)?.value || '';
  let embroideryColorValue = formElement.querySelector(`input[name="properties[_Embroidery Color Value]"]`)?.value || '';

  // 如果form内部没有找到，查找通过form属性关联的外部元素
  const formId = formElement.getAttribute('id');
  if (formId && (!embroideryText || !embroideryFont || !embroideryColor || !embroideryColorValue)) {
    console.log('🔍 Form内部未找到完整刺绣信息，查找form外部关联元素...');

    if (!embroideryText) {
      embroideryText = document.querySelector(`input[name="properties[Embroidery Text]"][form="${formId}"]`)?.value || '';
    }

    if (!embroideryFont) {
      embroideryFont = document.querySelector(`input[name="properties[Embroidery Font]"][form="${formId}"]`)?.value || '';
    }

    if (!embroideryColor) {
      embroideryColor = document.querySelector(`input[name="properties[Embroidery Color]"][form="${formId}"]`)?.value || '';
    }

    if (!embroideryColorValue) {
      embroideryColorValue = document.querySelector(`input[name="properties[_Embroidery Color Value]"][form="${formId}"]`)?.value || '';
    }

    console.log('🔍 外部关联刺绣信息检查结果:', {
      embroideryText: embroideryText,
      embroideryFont: embroideryFont,
      embroideryColor: embroideryColor,
      embroideryColorValue: embroideryColorValue
    });
  }
  
  console.log('🎨 Embroidery data collected:', {
    text: embroideryText,
    font: embroideryFont,
    color: embroideryColor,
    colorValue: embroideryColorValue
  });
  
  // Add embroidery properties to main product
  if (embroideryText) {
    mainProduct.properties["Embroidery Text"] = embroideryText;
  }
  if (embroideryFont) {
    mainProduct.properties["Embroidery Font"] = embroideryFont;
  }
  if (embroideryColor) {
    mainProduct.properties["Embroidery Color"] = embroideryColor;
  }
  if (embroideryColorValue) {
    mainProduct.properties["_Embroidery Color Value"] = embroideryColorValue;
  }
  
  // Get main product title for addon reference
  const mainProductTitle = document.querySelector('.product-title')?.textContent?.trim() || 'Product';
  
  // Build simplified embroidery product with minimal properties
  const embroideryProduct = {
    id: embroideryVariantId,
    quantity: parseInt(quantity),
    properties: {
      "Addon For ": mainProductTitle,
      "_addonToken": addonToken
    }
  };
  
  // Build the combined payload
  const payload = {
    items: [mainProduct, embroideryProduct],
    sections: "mini-cart"
  };
  
  console.log('📦 Built combined embroidery payload:', payload);
  
  try {
    console.log('🚀 Sending combined cart request to:', `${Shopify.routes.root}cart/add.js`);
    console.log('📤 Request payload:', JSON.stringify(payload, null, 2));
    
    // Send the combined request
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(payload),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    console.log('📥 Response status:', response.status, response.statusText);
    
    if (response.ok) {
      console.log('✅ Successfully added both products to cart');

      // Trigger cart refresh to update UI
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Return response without reading it - let the caller handle the JSON parsing
      return response;
    } else {
      const errorText = await response.text();
      console.error('❌ Failed to add combined products to cart:', errorText);
      console.error('📤 Failed request payload was:', JSON.stringify(payload, null, 2));
      throw new Error(`Failed to add products: ${errorText}`);
    }
    
  } catch (error) {
    console.error('💥 Error adding embroidery products to cart:', error);
    console.error('📤 Failed request payload was:', JSON.stringify(payload, null, 2));
    
    // Additional error details
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      console.error('🌐 Network error - check internet connection and Shopify availability');
    }
    
    throw error;
  }
}

// 验证函数是否成功定义
console.log('✅ window.addToCartEmbroidery function defined:', typeof window.addToCartEmbroidery);
console.log('🎯 ===== LL-EMBROIDERY.JS FUNCTION DEFINITION COMPLETE =====');

// 全局清理空的 cart-addon-item 元素的函数
window.cleanupEmptyEmbroideryAddonItems = function() {
  console.log('🧹 Global cleanup: Removing empty embroidery addon items...');

  const allAddonItems = document.querySelectorAll('cart-addon-item.ll-embroidery-addon');
  let removedCount = 0;

  allAddonItems.forEach((item, index) => {
    const detailsContainer = item.querySelector('.cart-product-addon-details');

    if (detailsContainer) {
      // 检查详情容器是否为空
      const hasContent = detailsContainer.children.length > 0 ||
                       detailsContainer.textContent.trim().length > 0;

      if (!hasContent) {
        console.log(`🗑️ Removing empty embroidery addon item ${index}`);
        item.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
        item.style.opacity = '0';
        item.style.transform = 'translateY(-10px)';

        setTimeout(() => {
          if (item.parentNode) {
            item.remove();
          }
        }, 300);

        removedCount++;
      }
    }
  });

  console.log(`🧹 Cleanup complete: Removed ${removedCount} empty addon items`);
  return removedCount;
};

// Helper function to generate UUID for addon token
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Note: establishProductAssociation function removed - no longer needed with new combined add logic

// Global function to validate and fix cart embroidery state
window.validateCartEmbroideryState = async function() {
  try {
    console.log('Validating cart embroidery state with new addon token logic...');
    
    // Get current cart
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data');
    }
    
    const cart = await cartResponse.json();
    const itemsToUpdate = [];
    
    // Group items by addon token to check for consistency
    const addonGroups = new Map();
    
    for (const item of cart.items) {
      const addonToken = item.properties?._addonToken;
      if (addonToken) {
        if (!addonGroups.has(addonToken)) {
          addonGroups.set(addonToken, []);
        }
        addonGroups.get(addonToken).push(item);
      }
    }
    
    // Check each addon group for orphaned items
    for (const [token, items] of addonGroups) {
      const hasMainProduct = items.some(item => item.properties?._hasAddons === true || item.properties?._hasAddons === 'true');
      const hasEmbroideryProduct = items.some(item => 
        item.properties?.['Addon For '] || 
        item.product?.handle === 'embroidery-service' ||
        item.product?.handle?.includes('embroidery')
      );
      
      // If we have embroidery but no main product, clean up the embroidery
      if (hasEmbroideryProduct && !hasMainProduct) {
        console.warn(`Found orphaned embroidery products for token ${token}, cleaning up...`);
        
        for (const item of items) {
          if (item.properties?.['Addon For '] || 
              item.product?.handle === 'embroidery-service' ||
              item.product?.handle?.includes('embroidery')) {
            // Remove orphaned embroidery items
            itemsToUpdate.push({
              id: item.key,
              quantity: 0  // Remove the item
            });
          }
        }
      }
      
      // If we have main product but no embroidery, clean up addon properties
      if (hasMainProduct && !hasEmbroideryProduct) {
        console.warn(`Found main product without embroidery for token ${token}, cleaning up addon properties...`);
        
        for (const item of items) {
          if (item.properties?._hasAddons) {
            const cleanProperties = {};
            for (const [key, value] of Object.entries(item.properties || {})) {
              if (key !== '_addonToken' && key !== '_hasAddons') {
                cleanProperties[key] = value;
              }
            }
            
            itemsToUpdate.push({
              id: item.key,
              quantity: item.quantity,
              properties: cleanProperties
            });
          }
        }
      }
    }
    
    // Update items
    for (const updateData of itemsToUpdate) {
      console.log('Cleaning up cart item:', updateData);
      
      const updateResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(updateData)
      });
      
      if (!updateResponse.ok) {
        const errorText = await updateResponse.text();
        console.error('Failed to clean up cart item:', errorText);
      } else {
        console.log('Successfully cleaned up cart item');
      }
    }
    
    if (itemsToUpdate.length > 0) {
      console.log(`Cleaned up ${itemsToUpdate.length} cart items with inconsistent addon state`);
      // 不要触发 cart:refresh 事件，避免死循环
      return true;
    } else {
      console.log('Cart embroidery state is consistent');
      return false;
    }
    
  } catch (error) {
    console.error('Error validating cart embroidery state:', error);
    return false;
  }
};

// Test function to validate embroidery removal functionality
window.testEmbroideryRemoval = async function() {
  try {
    console.log('Testing embroidery removal functionality...');
    
    // Get current cart
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data');
    }
    
    const cart = await cartResponse.json();
    console.log('Current cart items:', cart.items.length);
    
    // Find items with embroidery properties
    const itemsWithEmbroidery = cart.items.filter(item => {
      const hasEmbroideryProps = Object.keys(item.properties || {}).some(key => 
        key.toLowerCase().includes('embroidery') || 
        key.toLowerCase().includes('刺绣') ||
        key.startsWith('_embroidery')
      );
      return hasEmbroideryProps;
    });
    
    console.log(`Found ${itemsWithEmbroidery.length} items with embroidery properties:`, 
      itemsWithEmbroidery.map(item => ({
        key: item.key,
        title: item.title,
        properties: item.properties
      }))
    );
    
    if (itemsWithEmbroidery.length === 0) {
      console.log('No items with embroidery found in cart');
      return true;
    }
    
    // Test removal for the first item
    const testItem = itemsWithEmbroidery[0];
    console.log('Testing removal for item:', testItem.key);
    
    const addonElement = document.querySelector(`cart-addon-item[data-line-key="${testItem.key}"]`);
    if (addonElement) {
      console.log('Found addon element, testing removal...');
      await addonElement.removeEmbroidery(testItem.key);
      
      // Wait a bit for the operation to complete
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Verify removal
      const updatedCartResponse = await fetch(`${Shopify.routes.root}cart.js`);
      if (updatedCartResponse.ok) {
        const updatedCart = await updatedCartResponse.json();
        const updatedItem = updatedCart.items.find(item => item.variant_id === testItem.variant_id);
        
        if (updatedItem) {
          const stillHasEmbroidery = Object.keys(updatedItem.properties || {}).some(key => 
            key.toLowerCase().includes('embroidery') || 
            key.toLowerCase().includes('刺绣') ||
            key.startsWith('_embroidery')
          );
          
          if (stillHasEmbroidery) {
            console.error('Test failed: Embroidery properties still exist after removal');
            return false;
          } else {
            console.log('Test passed: Embroidery properties successfully removed');
            return true;
          }
        } else {
          console.log('Test passed: Product was completely removed from cart');
          return true;
        }
      }
    } else {
      console.log('No addon element found for testing');
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Error testing embroidery removal:', error);
    return false;
  }
};

// Global function to handle main product removal and cleanup
window.handleMainProductRemoval = async function() {
  try {
    if (!window.embroideryControllers) {
      return;
    }

    // Get current cart
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    if (!cartResponse.ok) {
      return;
    }
    
    const cart = await cartResponse.json();
    const cartVariantIds = cart.items.map(item => item.variant_id.toString());
    
    // Check each registered controller
    for (const [variantId, controller] of Object.entries(window.embroideryControllers)) {
      // If the main product is no longer in cart
      if (!cartVariantIds.includes(variantId)) {
        console.log('Main product removed, cleaning up embroidery for variant:', variantId);
        
        // Check if there are any embroidery-service products still in cart for this variant
        const embroideryItems = cart.items.filter(item => {
          // Check if this is an embroidery service product
          return item.product.handle === 'embroidery-service' || 
                 item.product.handle.includes('embroidery');
        });
        
        // Remove any orphaned embroidery service products
        for (const embroideryItem of embroideryItems) {
          // Check if this embroidery item was associated with the removed main product
          const hasAssociation = embroideryItem.properties && 
            Object.values(embroideryItem.properties).some(value => 
              value && value.toString().includes(variantId)
            );
          
          if (hasAssociation) {
            console.log('Removing orphaned embroidery product:', embroideryItem.key);
            await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: embroideryItem.key,
                quantity: 0
              })
            });
          }
        }
        
        // Reset the controller state
        if (controller && typeof controller.unselectEmbroidery === 'function') {
          // Just update the UI state without cart operations
          const blockId = controller.getBlockId?.();
          if (blockId) {
            const checkboxInput = document.querySelector(`[data-block-id="${blockId}"] [data-addon-checkbox-input]`);
            if (checkboxInput) {
              checkboxInput.checked = false;
            }
            
          }
        }
        
        // Remove from controllers registry
        delete window.embroideryControllers[variantId];
      }
    }
    
  } catch (error) {
    console.error('Error handling main product removal:', error);
  }
};

// Debug function for testing embroidery functionality
window.debugEmbroideryFunctionality = function() {
  console.log('🔧 === EMBROIDERY FUNCTIONALITY DEBUG ===');
  
  // 1. Check if addToCartEmbroidery function exists
  console.log('1. addToCartEmbroidery function exists:', typeof window.addToCartEmbroidery === 'function');
  
  // 2. Find all product forms
  const productForms = document.querySelectorAll('form[is="product-form"], form[id*="product-form"]');
  console.log('2. Product forms found:', productForms.length);
  productForms.forEach((form, index) => {
    console.log(`   Form ${index}:`, {
      id: form.id,
      action: form.action,
      hasAddonCheckbox: !!(form.querySelector('[data-addon-checkbox-input]') || form.querySelector('.ll-embroidery-checkbox-input')),
      hasEmbroideryInputs: !!form.querySelector('input[name*="embroidery"], input[name*="Embroidery"]')
    });
  });
  
  // 3. Check embroidery blocks
  const embroideryBlocks = document.querySelectorAll('[data-embroidery-block]');
  console.log('3. Embroidery blocks found:', embroideryBlocks.length);
  embroideryBlocks.forEach((block, index) => {
    console.log(`   Block ${index}:`, {
      value: block.getAttribute('data-embroidery-block'),
      variantId: block.getAttribute('data-variant-id'),
      dataset: block.dataset
    });
  });
  
  // 4. Check addon checkboxes (修复选择器)
  let addonCheckboxes = document.querySelectorAll('[data-addon-checkbox-input]');
  if (addonCheckboxes.length === 0) {
    addonCheckboxes = document.querySelectorAll('.ll-embroidery-checkbox-input');
  }
  console.log('4. Embroidery checkboxes found:', addonCheckboxes.length);
  addonCheckboxes.forEach((checkbox, index) => {
    console.log(`   Checkbox ${index}:`, {
      id: checkbox.id,
      checked: checkbox.checked,
      value: checkbox.value,
      className: checkbox.className,
      dataset: checkbox.dataset
    });
  });
  
  // 5. Check embroidery property inputs
  const embroideryInputs = document.querySelectorAll('input[name*="embroidery"], input[name*="Embroidery"]');
  console.log('5. Embroidery property inputs found:', embroideryInputs.length);
  embroideryInputs.forEach((input, index) => {
    console.log(`   Input ${index}:`, {
      name: input.name,
      value: input.value,
      disabled: input.disabled,
      type: input.type
    });
  });
  
  // 6. Test form submission interception
  console.log('6. Testing form submission detection...');
  if (productForms.length > 0) {
    const testForm = productForms[0];
    console.log('   Test form:', testForm.id);
    console.log('   Has submit event listener: checking...');
    
    // Simulate form data check
    const mainProductId = testForm.querySelector('[name="id"]')?.value;
    console.log('   Main product ID:', mainProductId);
    
    const embroideryText = testForm.querySelector('input[name="properties[Embroidery Text]"]')?.value;
    const embroideryFont = testForm.querySelector('input[name="properties[Embroidery Font]"]')?.value;
    const embroideryColor = testForm.querySelector('input[name="properties[Embroidery Color]"]')?.value;
    console.log('   Embroidery data:', { embroideryText, embroideryFont, embroideryColor });
  }
  
  // 7. Check Shopify globals
  console.log('7. Shopify environment check:', {
    shopifyExists: typeof Shopify !== 'undefined',
    routesExists: typeof Shopify?.routes?.root !== 'undefined',
    cartAddUrl: typeof Shopify !== 'undefined' ? `${Shopify.routes?.root}cart/add.js` : 'N/A'
  });
  
  console.log('🔧 === END DEBUG ===');
  
  return {
    productForms: productForms.length,
    embroideryBlocks: embroideryBlocks.length,
    addonCheckboxes: addonCheckboxes.length,
    embroideryInputs: embroideryInputs.length,
    addToCartEmbroideryExists: typeof window.addToCartEmbroidery === 'function'
  };
};

// Manual test function for adding embroidery products
window.testEmbroideryAddToCart = async function() {
  console.log('🧪 === TESTING EMBROIDERY ADD TO CART ===');
  
  const productForms = document.querySelectorAll('form[is="product-form"], form[id*="product-form"]');
  if (productForms.length === 0) {
    console.error('❌ No product forms found');
    return false;
  }
  
  const testForm = productForms[0];
  console.log('🧪 Testing with form:', testForm.id);
  
  // Check if embroidery data exists
  const embroideryText = testForm.querySelector('input[name="properties[Embroidery Text]"]')?.value;
  const embroideryFont = testForm.querySelector('input[name="properties[Embroidery Font]"]')?.value;
  const embroideryColor = testForm.querySelector('input[name="properties[Embroidery Color]"]')?.value;
  
  if (!embroideryText || !embroideryFont || !embroideryColor) {
    console.error('❌ Incomplete embroidery data for testing');
    console.log('💡 Set embroidery data first using: window.setTestEmbroideryData()');
    return false;
  }
  
  // Call addToCartEmbroidery directly
  try {
    const result = await window.addToCartEmbroidery(testForm);
    console.log('🧪 Test result:', result);
    return !!result;
  } catch (error) {
    console.error('🧪 Test failed:', error);
    return false;
  }
};

// Helper function to set test embroidery data
window.setTestEmbroideryData = function() {
  const embroideryTextInput = document.querySelector('input[name="properties[Embroidery Text]"]');
  const embroideryFontInput = document.querySelector('input[name="properties[Embroidery Font]"]');
  const embroideryColorInput = document.querySelector('input[name="properties[Embroidery Color]"]');
  
  if (embroideryTextInput) {
    embroideryTextInput.disabled = false;
    embroideryTextInput.value = 'Test Embroidery';
  }
  if (embroideryFontInput) {
    embroideryFontInput.disabled = false;
    embroideryFontInput.value = 'Arial';
  }
  if (embroideryColorInput) {
    embroideryColorInput.disabled = false;
    embroideryColorInput.value = 'Black';
  }
  
  console.log('✅ Test embroidery data set');
  return {
    text: embroideryTextInput?.value,
    font: embroideryFontInput?.value,
    color: embroideryColorInput?.value
  };
};

// Helper function to simulate checkbox selection for testing
window.simulateEmbroiderySelection = function() {
  // 找到刺绣checkbox
  let embroideryCheckbox = document.querySelector('.ll-embroidery-checkbox-input');
  if (!embroideryCheckbox) {
    embroideryCheckbox = document.querySelector('[data-addon-checkbox-input]');
  }
  
  if (embroideryCheckbox) {
    // 先设置测试数据
    window.setTestEmbroideryData();
    
    // 选中checkbox
    embroideryCheckbox.checked = true;
    
    // 触发change事件
    embroideryCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    
    console.log('✅ Simulated embroidery checkbox selection');
    return true;
  } else {
    console.error('❌ No embroidery checkbox found');
    return false;
  }
};

// Comprehensive test function for the complete flow
window.testCompleteEmbroideryFlow = async function() {
  console.log('🧪 === TESTING COMPLETE EMBROIDERY FLOW ===');
  
  // 1. 运行调试检查
  console.log('1. Running diagnostic...');
  const diagnosis = window.debugEmbroideryFunctionality();
  
  if (!diagnosis.addToCartEmbroideryExists) {
    console.error('❌ addToCartEmbroidery function not found');
    return false;
  }
  
  if (diagnosis.productForms === 0) {
    console.error('❌ No product forms found');
    return false;
  }
  
  if (diagnosis.embroideryBlocks === 0) {
    console.error('❌ No embroidery blocks found');
    return false;
  }
  
  // 2. 设置测试数据并选择checkbox
  console.log('2. Setting test data and selecting checkbox...');
  const selectionSuccess = window.simulateEmbroiderySelection();
  if (!selectionSuccess) {
    console.error('❌ Failed to simulate checkbox selection');
    return false;
  }
  
  // 3. 测试form interceptor
  console.log('3. Testing form submission with embroidery...');
  const productForms = document.querySelectorAll('form[is="product-form"], form[id*="product-form"]');
  if (productForms.length === 0) {
    console.error('❌ No product forms found for testing');
    return false;
  }
  
  const testForm = productForms[0];
  
  // 检查是否能检测到选中的checkbox
  const embroideryCheckbox = testForm.querySelector('.ll-embroidery-checkbox-input:checked') || 
                            testForm.querySelector('[data-addon-checkbox-input]:checked');
  
  if (!embroideryCheckbox) {
    console.error('❌ Checkbox not detected as checked in form');
    return false;
  }
  
  console.log('✅ Checkbox successfully detected as checked');
  
  // 4. 测试 addToCartEmbroidery 函数
  console.log('4. Testing addToCartEmbroidery function...');
  try {
    const result = await window.addToCartEmbroidery(testForm);
    if (result) {
      console.log('✅ addToCartEmbroidery returned a valid response');
      console.log('🧪 Test result:', result);
      return true;
    } else {
      console.error('❌ addToCartEmbroidery returned null');
      return false;
    }
  } catch (error) {
    console.error('❌ addToCartEmbroidery threw an error:', error);
    return false;
  }
};

// Initialize embroidery functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Auto-initialize any embroidery blocks that weren't manually initialized
  const embroideryBlocks = document.querySelectorAll('.ll-embroidery-block[data-auto-init="true"]');
  embroideryBlocks.forEach(block => {
    const blockId = block.dataset.blockId;
    if (blockId && !window[`embroidery_${blockId}`]) {
      window[`embroidery_${blockId}`] = new EmbroideryCustomization(blockId);
    }
  });
  
  // Listen for cart refresh events to handle main product removal
  document.addEventListener('cart:refresh', function() {
    setTimeout(() => {
      window.handleMainProductRemoval?.();
      window.validateCartEmbroideryState?.();
      // 清理空的刺绣 addon 元素
      window.cleanupEmptyEmbroideryAddonItems?.();
    }, 500);
  });
  
  // Validate cart state on page load
  setTimeout(() => {
    window.validateCartEmbroideryState();
  }, 1000);
  
  // Cart Addon Item Component for handling embroidery in cart
  if (typeof customElements !== 'undefined') {
    class CartAddonItem extends HTMLElement {
      constructor() {
        super();
        console.log('🎯 CartAddonItem constructor called');
        // Don't bind events in constructor, use connectedCallback instead
      }
      
      connectedCallback() {
        console.log('🔗 CartAddonItem connected to DOM');
        console.log('📋 Element dataset:', this.dataset);
        console.log('🏷️ Element classes:', this.className);
        console.log('📄 Element innerHTML preview:', this.innerHTML.substring(0, 200));
        this.bindEvents();
      }

      bindEvents() {
        console.log('🎯 CartAddonItem bindEvents called');
        
        // Debug: Show all buttons in this element
        const allButtons = this.querySelectorAll('button');
        console.log('🔍 All buttons in cart-addon-item:', allButtons.length);
        allButtons.forEach((btn, index) => {
          console.log(`  Button ${index}:`, {
            textContent: btn.textContent?.trim(),
            className: btn.className,
            dataset: btn.dataset,
            attributes: Array.from(btn.attributes).map(attr => `${attr.name}="${attr.value}"`).join(' ')
          });
        });
        
        // Handle remove button clicks
        const removeButton = this.querySelector('[data-addon-remove="embroidery"]');
        console.log('🔍 Found remove button with [data-addon-remove="embroidery"]:', !!removeButton);
        
        // Try alternative selectors
        const removeButtonAlt1 = this.querySelector('[data-addon-remove]');
        console.log('🔍 Found button with [data-addon-remove]:', !!removeButtonAlt1);
        
        const removeButtonAlt2 = this.querySelector('.cart-product-addon__remove');
        console.log('🔍 Found button with .cart-product-addon__remove:', !!removeButtonAlt2);
        
        // Skip the invalid :contains selector - it's not needed since we have other selectors
        console.log('🔍 Found button containing "Remove": skipped (using other selectors)');
        
        // Use the first available button
        const actualRemoveButton = removeButton || removeButtonAlt1 || removeButtonAlt2;
        
        if (actualRemoveButton) {
          console.log('✅ Using remove button:', {
            selector: removeButton ? '[data-addon-remove="embroidery"]' : (removeButtonAlt1 ? '[data-addon-remove]' : '.cart-product-addon__remove'),
            text: actualRemoveButton.textContent?.trim(),
            dataset: actualRemoveButton.dataset
          });
          
          actualRemoveButton.addEventListener('click', (event) => {
            console.log('❌ Remove button clicked!', event);
            event.preventDefault();
            event.stopPropagation();
            
            const lineKey = this.dataset.lineKey;
            console.log('🔑 Line key from cart-addon-item:', lineKey);
            console.log('📋 Full dataset:', this.dataset);
            
            if (lineKey) {
              console.log('🚀 Calling removeEmbroidery with lineKey:', lineKey);
              this.removeEmbroidery(lineKey);
            } else {
              console.error('❌ No line key found in dataset');
            }
          });
          
          console.log('🎉 Event listener attached successfully');
        } else {
          console.error('❌ No remove button found with any selector');
        }
      }

    // 隐藏并移除DOM元素的方法
    hideAndRemove() {
      this.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
      this.style.opacity = '0';
      this.style.transform = 'translateY(-10px)';

      setTimeout(() => {
        // 完全移除DOM元素而不是仅仅隐藏
        if (this.parentNode) {
          this.remove();
        }
      }, 300);
    }

    // 清理空的 cart-addon-item 元素
    cleanupEmptyAddonItems() {
      console.log('🧹 Cleaning up empty cart-addon-item elements...');

      // 查找所有 cart-addon-item 元素
      const allAddonItems = document.querySelectorAll('cart-addon-item');

      allAddonItems.forEach((item, index) => {
        // 检查是否为空的刺绣 addon item
        const isEmbroideryAddon = item.classList.contains('ll-embroidery-addon');
        const detailsContainer = item.querySelector('.cart-product-addon-details');

        if (isEmbroideryAddon && detailsContainer) {
          // 检查详情容器是否为空或只包含空白内容
          const hasContent = detailsContainer.children.length > 0 ||
                           detailsContainer.textContent.trim().length > 0;

          if (!hasContent) {
            console.log(`🗑️ Removing empty embroidery addon item ${index}`);
            item.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
            item.style.opacity = '0';
            item.style.transform = 'translateY(-10px)';

            setTimeout(() => {
              if (item.parentNode) {
                item.remove();
              }
            }, 300);
          }
        }
      });
    }

    async removeEmbroidery(lineKey) {
      let lineItem = null;
      let embroideryItem = null;
      let embroideryProductKey = null;
      
      console.log('🗑️ === STARTING EMBROIDERY REMOVAL ===');
      console.log('🔑 Line key:', lineKey);
      
      // 设置全局标志位，防止removeEmbroidery过程中重新添加embroidery-service
      window._isRemovingEmbroidery = true;
      
      try {
        // Show loading state
        const removeButton = this.querySelector('[data-addon-remove="embroidery"]');
        if (removeButton) {
          removeButton.textContent = 'Removing...';
          removeButton.disabled = true;
        }

        console.log('🚀 Attempting to remove embroidery for line key:', lineKey);

        // Get current cart
        const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
        if (!cartResponse.ok) {
          throw new Error('Failed to fetch cart data');
        }
        
        const cart = await cartResponse.json();
        console.log('Cart data:', cart);
        
        // Find the line item
        lineItem = cart.items.find(item => item.key === lineKey);
        if (!lineItem) {
          console.error('Available line items:', cart.items.map(item => ({ key: item.key, title: item.title })));
          throw new Error(`Line item not found for key: ${lineKey}`);
        }

        console.log('📋 Found line item:', lineItem);
        console.log('🔍 Line item properties:', lineItem.properties);

        // Step 1: Find and remove associated embroidery service product from cart
        // 新逻辑：通过_addonToken匹配关联的embroidery-service产品
        const addonToken = lineItem.properties?._addonToken;
        console.log('🎫 Addon token from line item:', addonToken);
        
        if (addonToken) {
          // 找到匹配的embroidery-service产品
          embroideryItem = cart.items.find(item => 
            item.properties?._addonToken === addonToken && 
            (item.product_title === 'embroidery-service' || item.handle === 'embroidery-service')
          );
          
          if (embroideryItem) {
            console.log('🎯 Found matching embroidery-service product:', embroideryItem.key);
            embroideryProductKey = embroideryItem.key;
          }
        }
        
        // Fallback：如果没有addonToken，尝试通过其他方式找到embroidery-service产品
        if (!embroideryItem) {
          console.log('⚠️ No addonToken or matching embroidery product found, trying fallback logic...');
          
          // 方法1：通过旧的_embroidery_product_key
          const oldEmbroideryKey = lineItem.properties?._embroidery_product_key;
          if (oldEmbroideryKey) {
            embroideryItem = cart.items.find(item => item.key === oldEmbroideryKey);
            if (embroideryItem) {
              console.log('🔄 Found embroidery product via old key:', oldEmbroideryKey);
              embroideryProductKey = oldEmbroideryKey;
            }
          }
          
          // 方法2：查找购物车中的embroidery-service产品（假设只有一个）
          if (!embroideryItem) {
            embroideryItem = cart.items.find(item => 
              item.product_title === 'embroidery-service' || item.handle === 'embroidery-service'
            );
            if (embroideryItem) {
              console.log('🔄 Found embroidery-service product by handle:', embroideryItem.key);
              embroideryProductKey = embroideryItem.key;
            }
          }
        }
        
        // 删除embroidery-service产品
        if (embroideryItem && embroideryProductKey) {
          console.log('🗑️ Removing embroidery product with key:', embroideryProductKey);

          // 找到该产品在购物车中的行号（从1开始）
          const lineNumber = cart.items.findIndex(item => item.key === embroideryProductKey) + 1;
          console.log('🔍 Embroidery product line number:', lineNumber);

          const removeResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: lineNumber,
              quantity: 0
            })
          });
          
          if (!removeResponse.ok) {
            const errorText = await removeResponse.text();
            console.error('❌ Failed to remove embroidery product:', errorText);
            throw new Error(`Failed to remove embroidery product: ${errorText}`);
          }
          
          console.log('✅ Successfully removed embroidery product');
        } else {
          console.warn('⚠️ No embroidery product found to remove');
        }

        // Step 2: Create clean properties without any embroidery attributes
        const cleanProperties = {};
        let hasNonEmbroideryProperties = false;
        
        for (const [key, value] of Object.entries(lineItem.properties || {})) {
          const keyLower = key.toLowerCase();
          // Remove all embroidery-related properties including the new structure
          if (!keyLower.includes('embroidery') && 
              !keyLower.includes('刺绣') && 
              !key.startsWith('_embroidery') &&
              key !== 'Embroidery Text' &&
              key !== 'Embroidery Font' &&
              key !== 'Embroidery Color' &&
              key !== '_Embroidery Color Value') {
            cleanProperties[key] = value;
            hasNonEmbroideryProperties = true;
          }
        }
        
        console.log('Clean properties after embroidery removal:', cleanProperties);
        console.log('Has non-embroidery properties:', hasNonEmbroideryProperties);

        // Step 3: Store product information for re-addition
        const productInfo = {
          id: lineItem.variant_id,  // Shopify cart/add.js expects 'id', not 'variant_id'
          quantity: lineItem.quantity,
          properties: hasNonEmbroideryProperties ? cleanProperties : {}
        };

        console.log('Product info for re-addition:', productInfo);

        // Step 4: Remove the current product completely
        console.log('Removing original product with line key:', lineKey);

        // 找到该产品在购物车中的行号（从1开始）
        const updatedCart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        const originalLineNumber = updatedCart.items.findIndex(item => item.key === lineKey) + 1;
        console.log('🔍 Original product line number:', originalLineNumber);

        const removeProductResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            line: originalLineNumber,
            quantity: 0
          })
        });

        if (!removeProductResponse.ok) {
          const errorText = await removeProductResponse.text();
          console.error('Failed to remove original product:', errorText);
          throw new Error(`Failed to remove original product: ${errorText}`);
        }

        console.log('Successfully removed original product');

        // Step 5: Re-add the product without embroidery properties
        console.log('Re-adding product without embroidery properties');
        
        // Ensure properties is not empty object but undefined if no properties
        if (!hasNonEmbroideryProperties || Object.keys(productInfo.properties).length === 0) {
          delete productInfo.properties;
        }
        
        console.log('Final product info for addition:', productInfo);
        
        const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [productInfo]
          })
        });

        if (!addResponse.ok) {
          const errorText = await addResponse.text();
          console.error('Failed to re-add product:', errorText);
          throw new Error(`Failed to re-add product: ${errorText}`);
        }

        const addResult = await addResponse.json();
        console.log('Successfully re-added product, result:', addResult);

        // Step 6: Verify the result
        const verificationResponse = await fetch(`${Shopify.routes.root}cart.js`);
        if (verificationResponse.ok) {
          const updatedCart = await verificationResponse.json();
          const newItem = updatedCart.items.find(item => item.variant_id === lineItem.variant_id);
          
          if (newItem) {
            console.log('Verification - New item properties:', newItem.properties);
            const hasEmbroideryProps = Object.keys(newItem.properties || {}).some(key => 
              key.toLowerCase().includes('embroidery') || 
              key.toLowerCase().includes('刺绣') ||
              key.startsWith('_embroidery')
            );
            
            if (hasEmbroideryProps) {
              console.warn('Warning: Embroidery properties still exist after replacement');
            } else {
              console.log('Success: All embroidery properties have been removed');
            }
          }
        }

        // Hide the embroidery addon element with a smooth animation
        this.hideAndRemove();
        

        // 通知对应的ll-embroidery-container控制器更新checkbox状态
        this.notifyEmbroideryControllerRemoval(lineItem);
        
        // Validate and fix any remaining cart inconsistencies
        setTimeout(() => {
          window.validateCartEmbroideryState?.();
        }, 500);
        
        // Dispatch cart refresh event
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // 延迟清理空的 cart-addon-item 元素
        setTimeout(() => {
          this.cleanupEmptyAddonItems();
        }, 1000);

        // 成功完成，清除标志位
        window._isRemovingEmbroidery = false;

      } catch (error) {
        console.error('Error removing embroidery:', error);
        
        // If product removal succeeded but re-addition failed, try to restore the original product
        if (error.message.includes('Failed to re-add product')) {
          console.log('Attempting to restore original product after failed re-addition...');
          try {
            // Try to restore the original product with all its properties
            const restoreProductInfo = {
              id: lineItem.variant_id,  // Use 'id' instead of 'variant_id'
              quantity: lineItem.quantity
            };
            
            // Only add properties if they exist and are not empty
            if (lineItem.properties && Object.keys(lineItem.properties).length > 0) {
              restoreProductInfo.properties = lineItem.properties;
            }
            
            const restoreResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [restoreProductInfo]
              })
            });
            
            if (restoreResponse.ok) {
              console.log('Successfully restored original product');
              // Also try to restore the embroidery product if it was removed
              if (embroideryProductKey && embroideryItem) {
                try {
                  const restoreEmbroideryInfo = {
                    id: embroideryItem.variant_id,  // Use 'id' instead of 'variant_id'
                    quantity: embroideryItem.quantity
                  };
                  
                  // Only add properties if they exist and are not empty
                  if (embroideryItem.properties && Object.keys(embroideryItem.properties).length > 0) {
                    restoreEmbroideryInfo.properties = embroideryItem.properties;
                  }
                  
                  await fetch(`${Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                      items: [restoreEmbroideryInfo]
                    })
                  });
                  console.log('Successfully restored embroidery product');
                } catch (restoreEmbroideryError) {
                  console.error('Failed to restore embroidery product:', restoreEmbroideryError);
                }
              }
            } else {
              console.error('Failed to restore original product');
            }
          } catch (restoreError) {
            console.error('Failed to restore original product:', restoreError);
          }
        }
        
        // Reset button state
        const removeButton = this.querySelector('[data-addon-remove="embroidery"]');
        if (removeButton) {
          removeButton.textContent = 'Remove';
          removeButton.disabled = false;
        }
        
        // Show error message with more details
        const errorMessage = `Failed to remove embroidery: ${error.message}. Please refresh the page and try again.`;
        console.error(errorMessage);

        // 即使出错也要移除DOM元素，避免留下空样式
        this.hideAndRemove();
      } finally {
        // 无论成功还是失败，都清除标志位
        window._isRemovingEmbroidery = false;
      }
    }

    // 通知对应的ll-embroidery-container控制器更新状态
    notifyEmbroideryControllerRemoval(lineItem) {
      try {
        if (!lineItem || !window.embroideryControllers) {
          return;
        }

        // 查找对应的控制器
        const controller = window.embroideryControllers[lineItem.variant_id];
        if (controller) {
          console.log('Found embroidery controller for variant:', lineItem.variant_id);
          
          // 调用控制器的unselectEmbroidery方法来更新checkbox状态
          // 但不再次删除购物车产品（因为已经删除了）
          if (typeof controller.unselectEmbroidery === 'function') {
            // 获取对应的block ID
            const blockId = controller.getBlockId?.();
            if (blockId) {
              // 直接更新状态，不执行购物车操作
              const checkboxInput = document.querySelector(`[data-block-id="${blockId}"] [data-addon-checkbox-input]`);
              if (checkboxInput) {
                checkboxInput.checked = false;
              }
              
              // 清空属性值并禁用字段
              const textInput = document.getElementById(`properties-embroidery-text-${blockId}`);
              const fontInput = document.getElementById(`properties-embroidery-font-${blockId}`);
              const colorInput = document.getElementById(`properties-embroidery-color-${blockId}`);
              const colorValueInput = document.getElementById(`properties-embroidery-color-value-${blockId}`);
              const productKeyInput = document.getElementById(`properties-embroidery-product-key-${blockId}`);
              
              const inputs = [textInput, fontInput, colorInput, colorValueInput, productKeyInput];
              inputs.forEach(input => {
                if (input) {
                  input.value = '';
                  input.disabled = true;
                }
              });
              
            }
            
            console.log('Notified embroidery controller of removal');
          }
        } else {
          console.log('No embroidery controller found for variant:', lineItem.variant_id);
        }
      } catch (error) {
        console.error('Error notifying embroidery controller:', error);
      }
    }
    }

    // Register the custom element
    if (!customElements.get('cart-addon-item')) {
      console.log('📝 Registering cart-addon-item custom element');
      customElements.define('cart-addon-item', CartAddonItem);
      console.log('✅ cart-addon-item registered successfully');
    } else {
      console.log('ℹ️ cart-addon-item already registered');
    }
    
    // Debug: Check current cart data and cart-addon-item elements
    setTimeout(async () => {
      console.log('🔍 === DEBUGGING CART DATA AND ELEMENTS ===');
      
      // 1. 获取当前购物车数据
      try {
        const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          console.log('🛒 Current cart data:', cartData);
          console.log('📦 Cart items:', cartData.items);
          
          cartData.items.forEach((item, index) => {
            console.log(`📦 Item ${index}:`, {
              title: item.title || item.product_title,
              handle: item.handle,
              key: item.key,
              properties: item.properties,
              hasAddonToken: !!item.properties?._addonToken,
              hasAddons: !!item.properties?._hasAddons,
              isEmbroideryService: item.handle === 'embroidery-service' || item.title?.includes('embroidery')
            });
          });
        }
      } catch (error) {
        console.error('❌ Failed to fetch cart data:', error);
      }
      
      // 2. 检查页面上的cart-addon-item元素
      const existingElements = document.querySelectorAll('cart-addon-item');
      console.log('🔍 Found cart-addon-item elements on page:', existingElements.length);
      existingElements.forEach((el, index) => {
        console.log(`  Element ${index}:`, {
          className: el.className,
          dataset: el.dataset,
          hasRemoveButton: !!el.querySelector('[data-addon-remove]'),
          innerHTML: el.innerHTML.substring(0, 100) + '...'
        });
      });
      
      // 3. 检查所有line-item元素
      const lineItems = document.querySelectorAll('line-item');
      console.log('📋 Found line-item elements:', lineItems.length);
      lineItems.forEach((el, index) => {
        const hasCartAddon = el.querySelector('cart-addon-item');
        console.log(`  Line item ${index}:`, {
          hasCartAddon: !!hasCartAddon,
          classes: el.className
        });
      });
      
      console.log('🔍 === END DEBUGGING ===');
    }, 2000);
  }
}); 